export default __webpack_public_path__ + "static/media/040-ambulance.5798d54f.png";